import React,{useState,useEffect} from 'react'
import useStyles from './styles';
import {TextField, Button, Typography, Paper} from '@material-ui/core';
import FileBase from 'react-file-base64';
import {useDispatch} from 'react-redux';
import {createPost,updatePost} from '../../actions/posts';
import {useSelector} from 'react-redux';

function Form({currentId,setcurrentId}) {
    const [postData, setPostData] = useState({ title:'', message:'', tags:'', selectedFile:'' });
    const post = useSelector((state) => currentId ? state.posts.find((p) =>p._id==currentId):null); //redux state
    const user = JSON.parse(localStorage.getItem('profile'));//geting the user data from localstorage 

    const classes = useStyles();
    const dispatch = useDispatch();

    useEffect(() => {
        if(post) setPostData(post);  
    }, [post])

    const clear =()=>{
        
        setcurrentId(null);
        setPostData({ title:'', message:'', tags:'', selectedFile:'' });
    }
    const handleSubmit =(e)=>{
        e.preventDefault();
        if(currentId ){
            dispatch(updatePost(currentId,{...postData,name:user?.result?.name}));
        }else{
            dispatch(createPost({...postData,name:user?.result?.name}));
        }
        clear();
    }

    if(!user?.result?.name){
        return (
            <Paper className={classes.paper}> 
                <Typography varient="h6" align="center">
                    To create memories or to like others memories, please signin!.
                </Typography>
            </Paper>
        )
    }    

    return (
        <Paper className={classes.paper}>
            <form autoComplete="off" noValidate className={`${classes.root} ${classes.form}`} onSubmit={handleSubmit}>
            <Typography variant="h6" >{currentId? 'Edit':'Create'} a memory</Typography>
            <TextField name="title" variant="outlined" label="Title" fullWidth value={postData.title} onChange={(e)=>setPostData({...postData,title: e.target.value})}/>
            <TextField name="message" variant="outlined" label="Message" fullWidth value={postData.message} onChange={(e)=>setPostData({...postData,message: e.target.value})}/>
            <TextField name="tags" variant="outlined" label="Tags" fullWidth value={postData.tags} onChange={(e)=>setPostData({...postData,tags: e.target.value})}/>
            
            
            <div className={classes.fileInput}>
                <FileBase
                    type="file"
                    multiple={false}
                    onDone={({base64})=>setPostData({...postData,selectedFile: base64})}
                />
            </div>
            <Button className={classes.buttonSubmit} variant="contained" color="primary" size="large"  type="submit" fullWidth>Submit</Button>
            <Button variant="contained" color="secondary" size="large" onClick={clear} fullWidth>Clear form</Button>
            </form>
        </Paper>
    )
}

export default Form;
